import Router from '@/router';
import Store from '@/store';

export const resolveStoreId = () => {
	const route = Router.currentRoute;
	const { storeId } = route.query;
	return storeId;
};

export const resolvePageId = () => {
	const route = Router.currentRoute;
	const { id } = route.query;
	return id || Store.getters.getPageId;
};

// TODO Get:fullCode
